module.exports = __webpack_public_path__ + "img/ad827b2e9963ffcff99b47c7cd1172bf.png";